import type {
  CreativeBriefFilterCountsResponse,
  CreativeBriefResponse
} from '@innovationdepartment/proxima-sdk-axios';

// Re-export domain types for convenience
export type { CreativeBriefFilterCountsResponse, CreativeBriefResponse };

// ─── Sort ────────────────────────────────────────────────────────────────────

export const SORT_DIRECTION = {
  Desc: 'desc',
  Asc: 'asc'
} as const;

export type SortDirection = (typeof SORT_DIRECTION)[keyof typeof SORT_DIRECTION];

// ─── Filter State ────────────────────────────────────────────────────────────

export interface CBFilterState {
  selectedStrategyIds: string[];
  selectedProductIds: number[];
  selectedFormats: string[];
  selectedMonths: string[];
  sortDirection: SortDirection;
  pageNumber: number;
  pageSize: number;
  visibleToCustomerOnly: boolean;
}

// ─── Filter Options (sidebar facets with counts) ─────────────────────────────

export interface StrategyFilterOption {
  strategyId: string;
  strategyName: string;
  count: number;
}

export interface ProductFilterOption {
  productId: number;
  productName: string;
  count: number;
}

export interface FormatFilterOption {
  format: string;
  count: number;
}

export interface MonthFilterOption {
  month: string;
  count: number;
}

export interface CBFilterOptions {
  strategies: StrategyFilterOption[];
  products: ProductFilterOption[];
  formats: FormatFilterOption[];
  months: MonthFilterOption[];
}

// ─── Filter Handlers ─────────────────────────────────────────────────────────

export interface CBFilterHandlers {
  toggleStrategyId: (id: string) => void;
  toggleProductId: (id: number) => void;
  toggleFormat: (format: string) => void;
  toggleMonth: (month: string) => void;
  setSortDirection: (dir: SortDirection) => void;
  setPage: (page: number) => void;
  resetFilters: () => void;
  setVisibleToCustomerOnly: (value: boolean) => void;
}

// ─── Visibility Toggle ───────────────────────────────────────────────────────

export type ToggleVisibilityFn = (briefId: string, visibleToCustomer: boolean) => Promise<void>;
